import { connect } from 'react-redux';
import MobileFilters from './MobileFilters';
import { setMobileFilterDrawerOpen } from '../store/customerAuthorizationSlice';

const mapState = state => ({
  isViewDrawerOpen: state.loadingManagement.customerAuthorizations.isViewDrawerOpen,
  mobileFilterDrawerOpen: state.loadingManagement.customerAuthorizations.mobileFilterDrawerOpen,
});

const mapDispatchToProps = { setMobileFilterDrawerOpen };

export default connect(mapState, mapDispatchToProps)(MobileFilters);
